module.exports = __webpack_public_path__ + "static/media/UserManualcCRA.1827aaad.pdf";